import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Badge } from '../ui/badge';
import { Code2, TrendingUp } from 'lucide-react';
import { ScrollArea } from '../ui/scroll-area';

const ProjectsModal = ({ isOpen, onClose, projects }) => {
  const getProjectIcon = (projectName) => {
    if (projectName.toLowerCase().includes('chatbot')) return <Code2 className="text-blue-500" size={28} />;
    if (projectName.toLowerCase().includes('dashboard')) return <TrendingUp className="text-blue-500" size={28} />;
    return <Code2 className="text-blue-500" size={28} />;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-950 border-slate-800 text-white max-w-4xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-3xl font-bold">Featured Projects</DialogTitle>
          <DialogDescription className="text-slate-400">
            Innovative solutions at the intersection of finance and technology
          </DialogDescription>
        </DialogHeader>
        
        <ScrollArea className="h-[60vh] pr-4">
          <div className="grid md:grid-cols-2 gap-6">
            {projects.map((project) => (
              <Card key={project.id} className="bg-slate-900 border-slate-800">
                <CardHeader>
                  <div className="mb-4">
                    {getProjectIcon(project.name)}
                  </div>
                  <CardTitle className="text-xl text-white mb-2">{project.name}</CardTitle>
                  <CardDescription className="text-slate-400 text-base">
                    {project.description}
                  </CardDescription>
                </CardHeader>
                
                <CardContent>
                  <div className="mb-4">
                    <p className="text-sm text-slate-500 mb-2 font-medium">Technologies:</p>
                    <div className="flex flex-wrap gap-2">
                      {project.technologies.map((tech, idx) => (
                        <Badge key={idx} variant="secondary" className="bg-blue-950 text-blue-400 border-blue-800">
                          {tech}
                        </Badge>
                      ))}
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <p className="text-sm text-slate-500 mb-2 font-medium">Status:</p>
                    <p className="text-slate-300 text-sm">{project.status}</p>
                  </div>
                  
                  <div>
                    <p className="text-sm text-slate-500 mb-2 font-medium">Key Highlights:</p>
                    <ul className="space-y-1">
                      {project.highlights.map((highlight, idx) => (
                        <li key={idx} className="text-slate-400 text-sm flex items-start gap-2">
                          <span className="text-blue-500 mt-0.5">•</span>
                          <span>{highlight}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectsModal;
